// composables/useBaseCart.ts
import { ref } from 'vue'
import type { AddToCartRequest } from '@/types/cartAccs'
import { useBuilderSessionService } from '@/services/builder_session.service'

export const useBaseCartAccs = () => {
    const isLoading = ref(false)
    const error = ref<Error | null>(null)
    const { ensureDesignProjectSaved } = useDesignProjectStore()
    const { loadMagentoProduct } = useAccsProductStore()

    //   Importing APIs from Guest Cart Service
    const { convertDesignerToLegacy } = useBuilderSessionService()
    const addDesignerProject = async (
        addToCartService: (
            payload: AddToCartRequest
        ) => Promise<{ data: Ref<unknown>; error: Ref<Error | null> }>
    ) => {
        isLoading.value = true
        error.value = null

        try {
            const designProjectStore = useDesignProjectStore()
            const { designProject } = storeToRefs(designProjectStore)
            // call designer project save
            await ensureDesignProjectSaved()

            // Pricing is now handled by productPrice store which watches designProject changes
            // No manual recalculation needed
            if (!designProject?.value) throw new Error('Design Project not ready')

            // Load Magento product to get designer project ID
            const designerProjectOption = await loadMagentoProduct(
                designProject.value.productData.sku
            )
            if (!designerProjectOption) throw new Error('Designer Project Option not ready')

            // prepare payload
            const enteredOptions = [
                { uid: designerProjectOption.projectId, value: designProject.value.id },
                { uid: designerProjectOption.customPriceId, value: designProject.value.total },
            ]
            if (designProject.value.total) {
                const payload = {
                    sku: designProject.value.productData.sku as string,
                    quantity: designProject.value.quantity as number,
                    entered_options: enteredOptions,

                    /* sku: designProject.value.productData.sku as string,
                    qty: designProject.value.quantity as number,
                    product_option: {
                        extension_attributes: {
                            custom_options: [
                                {
                                    option_id: designerProjectId,
                                    option_value: designProject.value.id,
                                },
                            ],
                        },
                    },
                    //   price: (designProject?.total / designProject.quantity) as number,
                    order_total: designProject.value.total, */
                }
                // call service
                const { error: addError } = await addToCartService(payload)
                if (addError?.value) throw addError.value

                const { error: legacyError } = await convertDesignerToLegacy(designProject.value)
                if (legacyError?.value) throw legacyError.value
            } else throw new Error('Total amount is 0')
        } catch (err) {
            error.value = err as Error
            throw error.value
        } finally {
            isLoading.value = false
        }
    }

    return { isLoading, error, addDesignerProject }
}
